// Simple email and password validation helpers for LoginPage

// Lightweight email validation regex that passes eslint rules
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailValid = (value: string) => {
  return emailRegex.test(value);
};

export const isPasswordValid = (value: string) => {
  return value.length >= 8;
};
